import { Fragment } from 'react';
import { Link, Outlet, useMatch } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import { Breadcrumb } from '@components/breadcrumb';
import { Button } from '@components/button';
import { RouterTabs } from '@components/header/router-tabs';
import { IconAddPlus } from '@components/icons/add-plus';
import { IconEmail } from '@components/icons/email';
import { IconInternalTasklist } from '@components/icons/internal-tasklist';
import { useIsMobile } from '@hooks/use-is-mobile';

import { Header } from 'components/headers';
import { useStore } from 'models/Provider';

export const Templates = observer(function Templates() {
  const { t } = useStore();
  const section = useMatch('/settings/templates/:section/*')?.params.section || 'emails';

  return (
    <Fragment>
      <Header
        // @ts-ignore why does this untyped component only complain about this prop
        mobileTitle={t('company.templates.crumbs.root')}
        actions={<Actions section={section} />}
        tabs={<TemplateTabs section={section} />}
        breadcrumbs={
          <Breadcrumb
            items={[{ label: t('company.templates.crumbs.root'), link: '/settings/templates' }]}
          />
        }
      />
      <Outlet />
    </Fragment>
  );
});

const Actions = observer<{ section: string }>(function Actions({ section }) {
  const { t } = useStore();
  const isMobile = useIsMobile();

  const link = `${section}/new`;
  const text = t(`company.templates.${section}.new`);

  return (
    <Link to={link} style={{ width: isMobile ? '100%' : 'auto' }}>
      <Button
        {...(isMobile && { style: { width: '100%' } })}
        iconLeft={<IconAddPlus />}
        text={text}
      />
    </Link>
  );
});

const TemplateTabs = observer<{ section: string }>(function TemplateTabs({ section }) {
  const { t } = useStore();

  return (
    <RouterTabs
      ariaLabel={t('company.templates.tabs.label')}
      activeSection={section}
      tabs={[
        {
          label: t('company.templates.tabs.emails'),
          to: 'emails',
          section: 'emails',
          icon: <IconEmail />,
        },
        {
          label: t('company.templates.tabs.tasks'),
          to: 'tasks',
          section: 'tasks',
          icon: <IconInternalTasklist />,
        },
      ]}
    />
  );
});
